






















































import { computed, defineComponent, ref, watch } from '@nuxtjs/composition-api';
import { clone } from 'lodash-es';

export default defineComponent({
  name: 'GenericMultiselect',
  model: {
    prop: 'modelValue',
  },
  props: {
    modelValue: {
      type: null,
      default: () => [],
    },
    options: {
      type: Array,
      required: true,
    },
    single: {
      type: Boolean,
      default: false,
    },
    immediate: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    hasTranslation: {
      type: Boolean,
      default: false,
    },
    identifiedBy: {
      // used to identify the option identifier in the model
      type: String,
      default: 'id',
    },
  },
  setup(props, { emit }) {
    const selectedOptions = ref<any[] | any>(clone(props.modelValue));
    /** controls showing more than 6 options */
    const showMoreOptions = ref<boolean>(false);

    /** options to be displayed initially (6 maximum) */
    const optionsToDisplay = computed(() => {
      if (props.options.length > 6) {
        return props.options.slice(0, 6);
      }
      return props.options;
    });

    /** options to be displayed after toggling show more (if any) */
    const moreOptions = computed(() => {
      if (props.options.length > 6) {
        return props.options.slice(6);
      }
      return [];
    });

    /**
     * a function that accept array of primitive type or array f object type
     * and return the value to be matched with in case of primitive type
     * and return the value of the identifiedBy property in case of object type
     */
    function getMatchedItem(options: any[], value: any): number {
      if (options.length && typeof options[0] === 'object' && options[0] !== null) {
        return options.findIndex(option => option[props.identifiedBy] === value[props.identifiedBy]) ?? -1;
      }
      return options.indexOf(options[0]);
    }

    /**
     * called on selecting one of the options
     * handles emitting the selected value throught an input event
     */
    function onSelect(value: any[] | Object[]) {
      if (props.single) {
        emit('input', value);
        return;
      }

      const newValue = clone(props.modelValue);
      const idx = getMatchedItem(newValue, value);
      if (idx >= 0) {
        newValue.splice(idx, 1);
      } else {
        newValue.push(value);
      }

      selectedOptions.value = newValue;
    }

    if (props.immediate) {
      watch(selectedOptions, newValue => {
        emit('input', newValue);
        emit('close');
      });
    }

    /**
     * Checks if an option is checked based on the model value
     */
    function isChecked(option: any) {
      return Array.isArray(selectedOptions.value)
        ? selectedOptions.value.find((opt: any) => opt.value === option.value)
        : selectedOptions.value?.value === option.value;
    }

    function apply() {
      emit('input', selectedOptions.value);
      emit('close');
    }

    function cancel() {
      selectedOptions.value = clone(props.modelValue);
      emit('close');
    }

    /**
     * Toggles the show more options if we have more than 6 options
     */
    function toggleShowMore() {
      showMoreOptions.value = true;
    }

    return {
      onSelect,
      isChecked,
      apply,
      cancel,
      toggleShowMore,
      optionsToDisplay,
      moreOptions,
      showMoreOptions,
    };
  },
});
